import { render } from "./EmailDetails.vue?vue&type=template&id=852121f4&scoped=true"
import script from "./EmailDetails.vue?vue&type=script&lang=js"
export * from "./EmailDetails.vue?vue&type=script&lang=js"

import "./EmailDetails.vue?vue&type=style&index=0&id=852121f4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-852121f4"]])

export default __exports__